import { Button } from '@/components/ui/button'
import { computeRead } from '@/hooks/auth'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { optimisticAtom, putFetcher } from '@/hooks'
import useSWRMutation from 'swr/mutation'
import { getRoles } from '@/constants/role'
import { useMemo } from 'react'
import { useRole } from '@/hooks/auth'
import { Role } from '@/constants/role'

const SetReadable = () => {
  const { id } = useParams()
  const roles = useMemo(() => getRoles(), [])

  const { data: user } = useSWR([`/users/${id}/full`])

  const isAdmin = useRole(Role.Admin, true)
  const isBuyerLeader = useRole(Role.BuyerLeader, true)
  const isRevenuerLeader = useRole(Role.RevenuerLeader, true)
  if (!isAdmin && !isBuyerLeader && !isRevenuerLeader) return null

  return (
    <div className="flex flex-wrap gap-4">
      {roles
        .filter((p) => {
          if (isAdmin) {
            return true
          } else if (isBuyerLeader) {
            return ['buyer', 'roaser'].includes(p.code)
          } else if (isRevenuerLeader) {
            return ['revenuer', 'admober'].includes(p.code)
          }
          return false
        })
        .map((p) => (
          <ToggleButton p={p} key={p.code} user={user} />
        ))}
    </div>
  )
}

const ToggleButton = ({ user, p }) => {
  const { code, name } = p
  const reads = user?.roles ?? []
  const { trigger } = useSWRMutation(`/users/${user?.id}`, putFetcher)

  const handleClick = () => {
    const value = computeRead(reads, code)
    const payload = { roles: value.split(',') }
    trigger(payload)
    optimisticAtom(`/users/${user?.id}/full`, payload)
  }

  const vari = reads.some((r) => r === code) ? 'default' : 'outline'

  return (
    <Button variant={vari} onClick={handleClick}>
      {name}
    </Button>
  )
}

export default SetReadable
